import { createInjectable } from 'ngxtension/create-injectable';
import { UserAgreementsApiService } from '../../../shared/services/user-agreements-api/user-agreements-api.service';
import { inject, effect, signal, computed } from '@angular/core';
import { Subject, switchMap, tap, catchError, EMPTY } from 'rxjs';
import { injectRumService } from '../../../shared/services/rum/rum.service';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationService } from '@/app/shared/components/navigation/navigation.service';

export const EulaService = createInjectable(
  () => {
    const userAgreementsApiService = inject(UserAgreementsApiService);
    const rumService = injectRumService();
    const router = inject(Router);
    const navigationService = inject(NavigationService);

    const loading = signal<boolean>(false);

    const acceptEulaSubject = new Subject<void>();

    const userAgreement = toSignal(
      acceptEulaSubject.pipe(
        tap(() => loading.set(true)),
        switchMap(() =>
          userAgreementsApiService
            .patchUserAgreements({ eula: true })
            .pipe(
              tap(() => {
                loading.set(false);
                rumService.awsRum()?.recordEvent('dpqa.custom.eula_accepted', {
                  licenseAgreement: true,
                  dataProcessingAgreement: true,
                  euAiActAgreement: true,
                });
              }),
              catchError(() => {
                // TODO have proper error handling here, but for now we just want to make sure the loading spinner is hidden again and the user can retry accepting the EULA.
                loading.set(false);
                return EMPTY;
              }),
            ),
        ),
      ),
    );

    const eulaAccepted = computed(() => userAgreement()?.eulaAcceptedAt !== undefined);

    effect(() => {
      if (eulaAccepted() && userAgreement()?.permissions) {
        router.navigate([navigationService.firstAllowedRoute(userAgreement()!.permissions!)?.link ?? '/error/403']);
      }
    });

    return {
      loading,
      eulaAccepted,
      acceptEula: () => acceptEulaSubject.next(),
    };
  },
  { providedIn: 'root' },
);
